<div class="card-lt-wrapper" [ngClass]="{'elevated': isElevated}">
  <div class="card-lt">
    <div class="card-lt-header flex-row space-between" [ngClass]="{clickable: _isHeaderClickable}" (click)="handleHeaderClick($event)">
      <div class="card-lt-title"><typography-legacy text-large-semibold>{{cardTitle}}</typography-legacy></div>
      <div class="card-lt-header-icon" *ngIf="_isHeaderClickable"><bw-icon-legacy size="24" iconName="chevron_right"></bw-icon-legacy></div>
    </div>
    
    <div class="card-lt-content">
      <ng-content select="[card-lt-content]"></ng-content>
    </div>

    <div *ngIf="hasFooter" class="card-lt-footer flex-row space-between" [ngClass]="{clickable: _isFooterClickable}" [ngStyle]="{'background-color': _footerColor, 'color': _footerIconColor}" (click)="handleFooterClick($event)">
      <bw-icon-legacy size="24" [iconName]="footerLeftIcon" [color]="_footerIconColor" class="mr-xs"></bw-icon-legacy>
      <div style="flex: 1 1 auto;">
        <typography-legacy class="type-sm-bold">{{footerText}}</typography-legacy>
      </div>
      <bw-icon-legacy size="24" [iconName]="footerRightIcon" [color]="_footerIconColor" ></bw-icon-legacy>
    </div>
  </div>
</div>
